import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import isPast from 'date-fns/is_past';
import classnames from 'classnames';
import {StarIcon} from 'icons';
import {checkPickIsFavorite} from 'selectors/favoritePicks';
import * as actions from 'actions/favoritePicks';
import {getPickResult, getPickTimestamp, pickOddsToFloat} from '../../helpers';

import './pickOdds.scss';

const PickOdds = ({pick, isFavorite, removeFavorite, addFavorite}) => {
  const isPastEvent = isPast(getPickTimestamp(pick.event));
  const isPickResolved = pick.status === 'resolved';

  const oddsClass = classnames({
    odds: true,
    win: getPickResult(pick) === true,
    lose: getPickResult(pick) === false,
  });

  return (
    <button
      type="button"
      disabled={isPastEvent}
      className={classnames('pick-odds', {active: isFavorite})}
      onClick={() => {
        if (isFavorite) {
          removeFavorite(pick.id);
        } else {
          addFavorite(pick);
        }
      }}
    >
      <span className={oddsClass}>{pickOddsToFloat(pick)}</span>
      {!isPastEvent && !isPickResolved && <StarIcon />}
    </button>
  );
};

PickOdds.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  pick: PropTypes.shape({
    id: PropTypes.string,
    odds: PropTypes.number,
    odd: PropTypes.number,
  }).isRequired,
  addFavorite: PropTypes.func.isRequired,
  removeFavorite: PropTypes.func.isRequired,
};

export default connect(
  (state, props) => ({
    isFavorite: checkPickIsFavorite({
      selection: props.pick.pick,
      eventId: props.pick.event.id,
    })(state),
  }),
  dispatch => ({
    addFavorite: pick => dispatch(actions.addFavorite(pick)),
    removeFavorite: pickId => dispatch(actions.removeFavorite(pickId)),
  }),
)(PickOdds);
